import { Layout } from 'shared/models';

export const Actions = {
    GET_LAYOUTS_REQUEST: 'GET_LAYOUTS_REQUEST',
    GET_LAYOUTS_SUCCESS: 'GET_LAYOUTS_SUCCESS',
    GET_LAYOUTS_FAILURE: 'GET_LAYOUTS_FAILURE',
};

export const getLayoutsRequest = () => ({
    type: Actions.GET_LAYOUTS_REQUEST,
});
export const getLayoutsSuccess = (layouts: ReadonlyArray<Layout>) => ({
    type: Actions.GET_LAYOUTS_SUCCESS,
    payload: layouts,
});
export const getLayoutsFailure = (err: Error) => ({
    type: Actions.GET_LAYOUTS_FAILURE,
    error: true,
    payload: err,
});
